export const TrackOptions = ["manager", "individualContributor"] as const;
export type TrackOption = (typeof TrackOptions)[number];

export function toIsReportingManager(track: TrackOption | null): boolean | undefined {
    return track ? track === "manager" : undefined;
}

export function toTrackOption(isReportingManager: boolean | undefined): TrackOption | null {
    if (isReportingManager === undefined) {
        return null;
    }

    return isReportingManager ? "manager" : "individualContributor";
}
